module.exports = __webpack_public_path__ + "img/AD_scale.fc3499b7.png";